// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__Gpr3_","rotation":"loader_rotation__rmPzk"};